import React from 'react'
import PropTypes from 'prop-types'
import styles from './Upload.scss'

const Upload = props =>
  <div className={styles.Upload}>
    {props.displayThumbnail && (
      <img className={styles.Thumbnail} src={props.uploadState.media.thumbnailSmallUri} />
    )}
    <input type='file'
      onChange={(event) => props.upload(event)}
      accept={props.accept || 'image/*'}
      style={{'display': props.hide ? 'none' : 'initial'}}
      ref={props.getRef} />
    <div className={styles.Status}>
      {props.uploadState.isUploading && 'Uploading ...'}
      {props.uploadState.uploaded && 'Successfully uploaded'}
      {props.uploadState.failed && ('Upload failed: ' + props.uploadState.failedMessage)}
    </div>
  </div>

Upload.propTypes = {
  hide: PropTypes.bool,
  accept: PropTypes.string,
  getRef: PropTypes.func,
  displayThumbnail: PropTypes.bool,
  upload: PropTypes.func.isRequired,
  uploadState: PropTypes.object.isRequired
}

export default Upload



// WEBPACK FOOTER //
// ./src/components/Upload/Upload.js